import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { compose } from 'redux';

import store from '../../store';
import { storesRestHooks } from '../../store/Stores/StoresSlice';
import { cashbackRatesRestHooks } from '../../store/Stores/CashbackRatesSlice';

import Stores from './components/Stores';

const StoresContainer = () => {
  const {
    loadStores,
    stores: { loadingStatus: storesLoadingState, items: stores },
  } = storesRestHooks.use();

  const { updateCashbackRate } = cashbackRatesRestHooks.use();

  useEffect(() => {
    loadStores();
  }, []);

  return (
    <div className="stores-container">
      <Stores
        stores={stores}
        storesLoadingState={storesLoadingState}
        onRateUpdate={updateCashbackRate}
        loadStores={loadStores}
      />
    </div>
  );
};

const addStore = (ProxyComponent) => (props) =>
  (
    <Provider store={store}>
      <ProxyComponent {...props} />
    </Provider>
  );

export default compose(addStore)(StoresContainer);
